import { useMutation } from '@tanstack/react-query';

import type { ReportRequestPayload } from '../report-requests.types';
import { reportRequestsService } from '../services/report-requests.service';

export interface CreateReportRequestVariables {
  payload: ReportRequestPayload;
}

export function useCreateReportRequest() {
  return useMutation<void, unknown, CreateReportRequestVariables>(({ payload }) =>
    reportRequestsService.createReportRequest(payload),
  );
}
